import axios from "axios";
import { req, reqF } from "./axiosFun";
import { reqBlob } from "./exportFile";

// 获取门店费用主表分页列表
export const GetStoreCostMainPageList = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetStoreCostMainPageList", params);
};
// 添加门店费用主表
export const AddStoreCostMain = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/AddStoreCostMain", params);
};
// 获取门店费用主表详情
export const GetStoreCostMainDetail = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetStoreCostMainDetail", params);
};

// 获取门店费用明细分页列表
export const GetStoreCostDtlPageList = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetStoreCostDtlPageList", params);
};
// 保存门店费用明细
export const SaveStoreCostDtl = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/SaveStoreCostDtl", params);
};
// 删除门店费用明细
export const DeleteStoreCostDtl = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/DeleteStoreCostDtl", params);
};
// 确认门店费用明细
export const ConfirmStoreCostDtl = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/ConfirmStoreCostDtl", params);
};
// 审核门店费用明细
export const AuditStoreCostDtl = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/AuditStoreCostDtl", params);
};
// 获取门店费用明细
export const GetStoreCostDtl = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetStoreCostDtl", params);
};
// 确认支付门店费用明细
export const PayStoreCostDtl = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/PayStoreCostDtl", params);
};

// 获取门店下拨费用分页列表
export const GetStoreAppropriationPageList = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetStoreAppropriationPageList", params);
};
// 保存门店下拨费用
export const SaveStoreAppropriation = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/SaveStoreAppropriation", params);
};
// 删除门店下拨费用
export const DeleteStoreAppropriation = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/DeleteStoreAppropriation", params);
};
// 确认门店下拨费用
export const ConfirmStoreAppropriation = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/ConfirmStoreAppropriation", params);
};
// 获取门店下拨费用详情
export const GetStoreAppropriationDetail = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetStoreAppropriationDetail", params);
};

// 获取门店费用统计
export const GetStoreCostStatistic = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetStoreCostStatistic", params);
};

// 获取考勤信息分页列表
export const GetAttendanceInfoPageList = (params) => {
	return reqF("post", "/api/sysConfig/Attendance/GetAttendanceInfoPageList", params);
};
// 获取今日考勤信息列表
export const GetAttendanceDayList = (params) => {
	return reqF("post", "/api/sysConfig/Attendance/GetAttendanceDayList", params);
};
// 新增考勤信息
export const AddAttendance = (params) => {
	return reqF("post", "/api/sysConfig/Attendance/AddAttendance", params);
};
// 获取考勤信息统计
export const GetAttendanceStatistic = (params) => {
	return reqF("post", "/api/sysConfig/Attendance/GetAttendanceStatistic", params);
};
// 导出考勤信息统计
export const ExportAttendanceStatistic = (params) => {
	return reqBlob("post", "/api/sysConfig/Attendance/ExportAttendanceStatistic", params);
};

// 获取报销费用分页列表
export const GetReimbursementPageList = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetReimbursementPageList", params);
};
// 保存报销费用
export const SaveReimbursement = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/SaveReimbursement", params);
};
// 删除报销费用
export const DeleteReimbursement = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/DeleteReimbursement", params);
};
// 获取报销费用详情
export const GetReimbursementDetail = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetReimbursementDetail", params);
};
// 确认报销费用
export const ConfirmReimbursement = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/ConfirmReimbursement", params);
};
// 支付报销费用
export const PayReimbursement = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/PayReimbursement", params);
};
// 导出报销单
export const ExportReimbursement = (params) => {
	return reqBlob("post", "/api/sysConfig/StoreCost/ExportReimbursement", params);
};

// 获取门店开销分页列表
export const GetStoreExpensePageList = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetStoreExpensePageList", params);
};
// 保存门店开销
export const SaveStoreExpense = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/SaveStoreExpense", params);
};
// 删除门店开销
export const DeleteStoreExpense = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/DeleteStoreExpense", params);
};
// 获取门店开销详情
export const GetStoreExpenseDetail = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/GetStoreExpenseDetail", params);
};
// 确认门店开销
export const ConfirmStoreExpense = (params) => {
	return reqF("post", "/api/sysConfig/StoreCost/ConfirmStoreExpense", params);
};
